import { useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import PasswordIcon from "../../../Assets/PasswordIcon.svg";
import loginlogo from "../../../Assets/loginlogo.svg";
import closeeye from "../../../Assets/closeeye.svg";
import eye from "../../../Assets/eye.svg";
import useIsAuth from "../../../hooks/useIsAuth";

import {
  forgotPassword,
  resetPasswordApi,
  isLinkExpired,
} from "../../../services/api";

import style from "../Login/login.module.css";
import swal from "sweetalert2";

export const ResetPassword = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    password: "",
    cnfPassword: "",
  });
  const [passwordType, setPasswordType] = useState(false);
  const [creatPasswordType, setcreatPasswordType] = useState(false);
  const changeHandler = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const navigate = useNavigate();

  const submitHandler = async () => {
    setLoading(true);
    if (formData.password != formData.cnfPassword) {
      swal.fire("Password & confirm password not match");
      swal.fire({
        icon: "error",
        text: "Create Password & Confirm Password do not match",
        timer: 1300,
      });
      setLoading(false);
      return;
    }

    try {
      const { data } = await resetPasswordApi(
        {
          password: formData.password,
        },
        token
      );

      setLoading(false);
      // swal.fire("Password Reset Successfully");
      swal.fire({
        icon: "success",
        text: "Password Reset Successfully",
        timer: 1300,
      });

      setInterval(() => {
        const pathname = window.location.pathname;
        const student = pathname;

        if (student.includes("student")) {
          window.location.href = "/hiring/student";
        } else {
          window.location.href = "/hiring/recruiter";
        }
      }, 2000);
    } catch (e) {
      setLoading(false);
    }
  };

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };
  const togglePassword1 = () => {
    setcreatPasswordType(!creatPasswordType);
  };

  useEffect(() => {
    let tokenIstrue;
    if (token) {
      const fetch = async () => {
        try {
          const tokenIstrue = await isLinkExpired(token);
        } catch (err) {
          if (err.response.data === false) {
            swal.fire({
              title: "Link Expired",
              text: "Please click on forgot password to reset password",
              icon: "error",
            });
            setInterval(() => {
              const pathname = window.location.pathname;
              const student = pathname;
              if (student.includes("student")) {
                window.location.href = "/hiring/student";
              } else {
                window.location.href = "/hiring/recruiter";
              }
            }, 2500);
          }
        }
      };
      fetch();
    } else {
      // alert("your token expired please click");
      swal.fire({
        icon: "error",
        text: "Your token expired please click",
        timer: 1300,
      });
    }
  }, [token]);

  return (
    <main className={style.login}>
      <div className={style.loginWrapper}>
        <div className={style.leftContainer}></div>
        <div className={style.rightContainer}>
          <div className={style.headingContainer}>
            <img src={loginlogo} alt="" />
            <h2>Welcome Back</h2>
          </div>
          <form className={style.loginForm}>
            <div className={style.inputField}>
              <div className={style.inputPrefix}>
                <img src={PasswordIcon} alt="PasswordIcon" />
              </div>
              <input
                type={!passwordType ? "password" : "text"}
                name="password"
                required
                value={formData.email}
                onChange={changeHandler}
                placeholder="Create New Password"
                autoComplete="off"
              />
              <div style={{ padding: "0.8rem" }}>
                <img
                  src={!passwordType ? closeeye : eye}
                  alt="PasswordIcon"
                  onClick={togglePassword}
                  className={style.eyeIcon}
                  style={
                    passwordType
                      ? { cursor: "pointer", width: "100%" }
                      : { cursor: "pointer", width: "100%", height: "90%" }
                  }
                />
              </div>
            </div>
            <div className={style.inputField}>
              <div className={style.inputPrefix}>
                <img src={PasswordIcon} alt="PasswordIcon" />
              </div>
              <input
                type={!creatPasswordType ? "password" : "text"}
                name="cnfPassword"
                required
                value={formData.email}
                onChange={changeHandler}
                placeholder="Confirm New Password"
                autoComplete="off"
              />
              <div style={{ padding: "0.8rem" }}>
                <img
                  src={!creatPasswordType ? closeeye : eye}
                  alt="PasswordIcon"
                  onClick={togglePassword1}
                  className={style.eyeIcon}
                  style={
                    passwordType ? { cursor: "pointer" } : { cursor: "pointer" }
                  }
                />
              </div>
            </div>

            <button type="button" onClick={submitHandler} disabled={loading}>
              {loading ? "Reseting..." : "Reset"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};
